import { render } from "./SolutionsSection.vue?vue&type=template&id=57960db8&scoped=true"
import script from "./SolutionsSection.vue?vue&type=script&lang=js"
export * from "./SolutionsSection.vue?vue&type=script&lang=js"

import "./SolutionsSection.vue?vue&type=style&index=0&id=57960db8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57960db8"]])

export default __exports__